import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Http} from '@angular/http';
// service
import {UserService} from '../service/user.service';

@Component({
  selector: 'verification',
  templateUrl: './verification.component.html'
})
export class VerificationComponent implements OnInit {
  currentUser: any;
  code: string;
  token: string;
  public showError: boolean;
  public errorMessage: string;

  constructor(private router: Router,
              private http: Http,
              private userService: UserService) {

    this.currentUser = {
      code: ''
    }
  }

  handleKey(e: any) {
    if (e.which == 13) this.verifyCode();
  }

  ngOnInit() {
  }

  verifyCode() {
    this.showError = false;
    this.errorMessage = '';
    this.code = this.currentUser.code;

    if (this.currentUser.code == '') {
      this.showError = true;
      this.errorMessage = 'Enter the code from the sms';
      return;
    }

    this.token = localStorage.getItem('auth_token');
    return this.userService.verifyCode(this.code, this.token)
      .subscribe((result) => {
          this.router.navigate(['/main']);
        },
        err => {
          this.errorMessage = 'Invalid Code';
          this.showError = true;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/verification/verification.component.ts